import { InputParameters, OutputParameters } from "./parameters";

## Input schema
<InputParameters version={props.version} />

## Output schema
<OutputParameters version={props.version} />
